import {Directive, Inject, AfterViewInit, Input} from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwFocusWhen
 * @module mw.components.focusWhen
 * @restrict A
 *
 * @description
 * `mw-focus-when` is an attribute directive will tell an input when to focus.
 *
 * @usage
 * <hljs hljs-language="html">
 * <div mw-focus-when="$ctrl.focusFlag">
 * </div>
 * </hljs>
 */
@Directive({
    selector: '[mwFocusWhen]'
})
export class FocusWhenDirective implements AfterViewInit {

    @Input('=') mwFocusWhen: string;
    @Input('<') mwSelectOnFocus: boolean;

    constructor(@Inject('$element') private $element: ng.IRootElementService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    ngAfterViewInit() {
        this.$scope.$watch(() => this.mwFocusWhen, shouldFocus => {
            if (shouldFocus) {
                this.$timeout(() => {
                    this.$element.focus();
                    if (this.mwSelectOnFocus) {
                        this.$element[0].setSelectionRange(0, this.$element[0].value.length);
                    }
                }, 80);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/input/focus-when.directive.ts